module.exports = __webpack_public_path__ + "img/lead-02z.b13ac9ca.png";